<template>
  <alzata-dialog
    ref="modal"
    size="lg"
    :title="'Delete Veterinarian'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <span for="name" class="small">Do you want delete "{{name}}"?</span>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide();">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="deleteVeterinarian">
        Delete
      </button>
    </template>
  </alzata-dialog>
</template>

<script>

export default {
  name: "DeleteVeterinarianDialog",
  emits: ["deleteVeterinarian"],
  components: {
  },
  mounted() {
    (async () => {
     
    })();
  },
  data() {
    return {
      veterinarian: null,
      name: null,
    };
  },
  methods: {
    show(veterinarian) {
      (async () => {
        this.veterinarian = veterinarian;
        this.name = veterinarian.name;

        this.$refs.modal.show();
      })();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteVeterinarian() {
      this.$emit("deleteVeterinarian", this.veterinarian);
    },
  },
};
</script>
